import React from "react";

// Temperature Icon
const Temperature = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Thermometer bulb */}
        <circle
          cx="50"
          cy="75"
          r="12"
          fill="rgb(239, 68, 68)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
        />
        
        {/* Thermometer tube */}
        <rect
          x="45"
          y="20"
          width="10"
          height="60"
          fill="none"
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
          rx="5"
        />
        
        {/* Mercury/fluid column */}
        <rect
          x="47"
          y="35"
          width="6"
          height="43"
          fill="rgb(239, 68, 68)"
          rx="3"
        />
        
        {/* Temperature scale marks */}
        <g stroke="rgb(143, 148, 151)" strokeWidth="1">
          <line x1="55" y1="25" x2="60" y2="25" />
          <line x1="55" y1="30" x2="58" y2="30" />
          <line x1="55" y1="35" x2="60" y2="35" />
          <line x1="55" y1="40" x2="58" y2="40" />
          <line x1="55" y1="45" x2="60" y2="45" />
          <line x1="55" y1="50" x2="58" y2="50" />
          <line x1="55" y1="55" x2="60" y2="55" />
        </g>
        
        {/* Temperature label */}
        <text
          x="70"
          y="30"
          fontSize="8"
          fill="rgb(143, 148, 151)"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          °C
        </text>
      </svg>
    </div>
  );
};

// Humidity Icon
const Humidity = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Water droplet shape */}
        <path
          d="M 50 20 C 35 35 25 50 25 65 C 25 78 36 85 50 85 C 64 85 75 78 75 65 C 75 50 65 35 50 20 Z"
          fill="rgb(59, 130, 246)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
        />
        
        {/* Water level indicator */}
        <path
          d="M 30 60 Q 35 58 40 60 T 50 60 T 60 60 T 70 60 L 70 65 C 70 75 62 80 50 80 C 38 80 30 75 30 65 Z"
          fill="rgb(37, 99, 235)"
        />
        
        {/* Highlight on droplet */}
        <ellipse
          cx="42"
          cy="45"
          rx="4"
          ry="8"
          fill="rgb(147, 197, 253)"
          opacity="0.7"
        />
        
        {/* Percentage symbol */}
        <text
          x="50"
          y="68"
          textAnchor="middle"
          fontSize="10"
          fill="white"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          %
        </text>
      </svg>
    </div>
  );
};

// Pressure Icon
const Pressure = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Gauge outer ring */}
        <circle
          cx="50"
          cy="55"
          r="30"
          fill="none"
          stroke="rgb(143, 148, 151)"
          strokeWidth="3"
        />
        
        {/* Gauge face */}
        <circle
          cx="50"
          cy="55"
          r="25"
          fill="rgb(249, 250, 251)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="1"
        />
        
        {/* Gauge markings */}
        <g stroke="rgb(143, 148, 151)" strokeWidth="2">
          <line x1="50" y1="30" x2="50" y2="35" />
          <line x1="70" y1="45" x2="65" y2="47" />
          <line x1="70" y1="65" x2="65" y2="63" />
          <line x1="50" y1="80" x2="50" y2="75" />
          <line x1="30" y1="65" x2="35" y2="63" />
          <line x1="30" y1="45" x2="35" y2="47" />
        </g>
        
        {/* Gauge needle */}
        <line
          x1="50"
          y1="55"
          x2="65"
          y2="47"
          stroke="rgb(239, 68, 68)"
          strokeWidth="2"
          strokeLinecap="round"
        />
        
        {/* Center pivot */}
        <circle
          cx="50"
          cy="55"
          r="3"
          fill="rgb(143, 148, 151)"
        />
        
        {/* Pressure label */}
        <text
          x="50"
          y="18"
          textAnchor="middle"
          fontSize="8"
          fill="rgb(143, 148, 151)"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          PSI
        </text>
      </svg>
    </div>
  );
};

// Distance Icon
const Distance = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Ruler body */}
        <rect
          x="20"
          y="40"
          width="60"
          height="20"
          fill="rgb(249, 250, 251)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
          rx="2"
        />
        
        {/* Ruler markings */}
        <g stroke="rgb(143, 148, 151)" strokeWidth="1">
          <line x1="25" y1="40" x2="25" y2="60" />
          <line x1="30" y1="45" x2="30" y2="55" />
          <line x1="35" y1="40" x2="35" y2="60" />
          <line x1="40" y1="45" x2="40" y2="55" />
          <line x1="45" y1="40" x2="45" y2="60" />
          <line x1="50" y1="45" x2="50" y2="55" />
          <line x1="55" y1="40" x2="55" y2="60" />
          <line x1="60" y1="45" x2="60" y2="55" />
          <line x1="65" y1="40" x2="65" y2="60" />
          <line x1="70" y1="45" x2="70" y2="55" />
          <line x1="75" y1="40" x2="75" y2="60" />
        </g>
        
        {/* Distance measurement arrows */}
        <path
          d="M 15 25 L 20 20 L 20 23 L 80 23 L 80 20 L 85 25 L 80 30 L 80 27 L 20 27 L 20 30 Z"
          fill="rgb(34, 197, 94)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="1"
        />
        
        {/* Numbers on ruler */}
        <text x="25" y="75" fontSize="6" fill="rgb(143, 148, 151)" textAnchor="middle">0</text>
        <text x="45" y="75" fontSize="6" fill="rgb(143, 148, 151)" textAnchor="middle">5</text>
        <text x="65" y="75" fontSize="6" fill="rgb(143, 148, 151)" textAnchor="middle">10</text>
      </svg>
    </div>
  );
};

// Air Quality Icon
const AirQuality = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Air particles - different sizes */}
        <circle cx="30" cy="35" r="3" fill="rgb(156, 163, 175)" opacity="0.8" />
        <circle cx="45" cy="25" r="2" fill="rgb(156, 163, 175)" opacity="0.6" />
        <circle cx="65" cy="30" r="4" fill="rgb(107, 114, 128)" opacity="0.9" />
        <circle cx="75" cy="45" r="2.5" fill="rgb(156, 163, 175)" opacity="0.7" />
        <circle cx="25" cy="55" r="3.5" fill="rgb(107, 114, 128)" opacity="0.8" />
        <circle cx="55" cy="50" r="2" fill="rgb(156, 163, 175)" opacity="0.6" />
        <circle cx="70" cy="65" r="3" fill="rgb(107, 114, 128)" opacity="0.8" />
        <circle cx="40" cy="70" r="2.5" fill="rgb(156, 163, 175)" opacity="0.7" />
        
        {/* Wind flow lines */}
        <g stroke="rgb(59, 130, 246)" strokeWidth="2" fill="none" opacity="0.7">
          <path d="M 15 40 Q 25 38 35 40 T 55 40" strokeLinecap="round" />
          <path d="M 20 60 Q 30 58 40 60 T 60 60" strokeLinecap="round" />
          <path d="M 25 80 Q 35 78 45 80 T 65 80" strokeLinecap="round" />
        </g>
        
        {/* Air quality indicator symbol */}
        <rect
          x="75"
          y="15"
          width="15"
          height="15"
          fill="none"
          stroke="rgb(143, 148, 151)"
          strokeWidth="1.5"
          rx="2"
        />
        
        {/* AQ text */}
        <text
          x="82.5"
          y="25"
          textAnchor="middle"
          fontSize="7"
          fill="rgb(143, 148, 151)"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          AQ
        </text>
      </svg>
    </div>
  );
};

// Light Icon
const Light = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Light bulb outline */}
        <path
          d="M 50 20 C 60 20 68 28 68 40 C 68 50 62 58 55 62 L 55 70 L 45 70 L 45 62 C 38 58 32 50 32 40 C 32 28 40 20 50 20 Z"
          fill="rgb(254, 240, 138)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
        />
        
        {/* Light bulb base/screw threads */}
        <rect
          x="42"
          y="70"
          width="16"
          height="8"
          fill="rgb(156, 163, 175)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="1"
        />
        
        {/* Screw thread lines */}
        <g stroke="rgb(143, 148, 151)" strokeWidth="0.5">
          <line x1="42" y1="72" x2="58" y2="72" />
          <line x1="42" y1="75" x2="58" y2="75" />
        </g>
        
        {/* Filament */}
        <path
          d="M 45 35 Q 50 30 55 35 Q 50 40 45 35"
          fill="none"
          stroke="rgb(251, 191, 36)"
          strokeWidth="1.5"
        />
        
        {/* Light rays */}
        <g stroke="rgb(251, 191, 36)" strokeWidth="2" strokeLinecap="round">
          <line x1="50" y1="10" x2="50" y2="15" />
          <line x1="25" y1="25" x2="29" y2="29" />
          <line x1="75" y1="25" x2="71" y2="29" />
          <line x1="15" y1="50" x2="20" y2="50" />
          <line x1="80" y1="50" x2="85" y2="50" />
          <line x1="25" y1="75" x2="29" y2="71" />
          <line x1="75" y1="75" x2="71" y2="71" />
        </g>
      </svg>
    </div>
  );
};

// Electricity Icon (for conductivity, voltage, etc.)
const Electricity = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Lightning bolt main shape */}
        <path
          d="M 45 15 L 35 45 L 48 45 L 42 70 L 65 40 L 52 40 L 58 15 Z"
          fill="rgb(251, 191, 36)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        
        {/* Lightning bolt inner highlight */}
        <path
          d="M 47 18 L 40 42 L 50 42 L 45 65 L 62 43 L 54 43 L 56 18 Z"
          fill="rgb(254, 240, 138)"
        />
        
        {/* Electrical circuit elements */}
        <g stroke="rgb(143, 148, 151)" strokeWidth="1.5" fill="none">
          {/* Positive terminal */}
          <line x1="15" y1="25" x2="25" y2="25" />
          <line x1="20" y1="20" x2="20" y2="30" />
          
          {/* Negative terminal */}
          <line x1="75" y1="75" x2="85" y2="75" />
          
          {/* Connecting wires */}
          <path d="M 25 25 Q 30 25 35 30" />
          <path d="M 65 70 Q 70 72 75 75" />
        </g>
        
        {/* Voltage indicator sparks */}
        <g fill="rgb(251, 191, 36)" opacity="0.8">
          <path d="M 20 40 L 22 38 L 24 40 L 22 42 Z" />
          <path d="M 76 60 L 78 58 L 80 60 L 78 62 Z" />
          <path d="M 85 30 L 87 28 L 89 30 L 87 32 Z" />
        </g>
        
        {/* Voltage text */}
        <text
          x="50"
          y="90"
          textAnchor="middle"
          fontSize="8"
          fill="rgb(143, 148, 151)"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          V
        </text>
      </svg>
    </div>
  );
};

// UV Icon
const UV = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Sun center */}
        <circle
          cx="50"
          cy="50"
          r="18"
          fill="rgb(251, 191, 36)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
        />
        
        {/* Sun rays */}
        <g stroke="rgb(251, 191, 36)" strokeWidth="3" strokeLinecap="round">
          <line x1="50" y1="15" x2="50" y2="25" />
          <line x1="78" y1="22" x2="71" y2="29" />
          <line x1="85" y1="50" x2="75" y2="50" />
          <line x1="78" y1="78" x2="71" y2="71" />
          <line x1="50" y1="85" x2="50" y2="75" />
          <line x1="22" y1="78" x2="29" y2="71" />
          <line x1="15" y1="50" x2="25" y2="50" />
          <line x1="22" y1="22" x2="29" y2="29" />
        </g>
        
        {/* UV waves inside sun */}
        <g stroke="rgb(245, 158, 11)" strokeWidth="1.5" fill="none">
          <path d="M 40 45 Q 45 42 50 45 T 60 45" />
          <path d="M 40 50 Q 45 47 50 50 T 60 50" />
          <path d="M 40 55 Q 45 52 50 55 T 60 55" />
        </g>
        
        {/* UV text */}
        <text
          x="50"
          y="52"
          textAnchor="middle"
          fontSize="8"
          fill="rgb(180, 83, 9)"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          UV
        </text>
      </svg>
    </div>
  );
};

// Weather Icon
const Weather = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Large cloud */}
        <path
          d="M 25 55 C 25 45 32 35 42 35 C 45 30 52 25 60 30 C 65 25 75 30 75 40 C 80 40 85 45 85 50 C 85 55 80 60 75 60 L 30 60 C 25 60 20 55 25 55 Z"
          fill="rgb(209, 213, 219)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
        />
        
        {/* Small cloud */}
        <path
          d="M 15 40 C 15 35 18 30 23 30 C 25 27 30 25 35 28 C 38 25 43 28 43 33 C 46 33 49 36 49 39 C 49 42 46 45 43 45 L 18 45 C 15 45 12 42 15 40 Z"
          fill="rgb(229, 231, 235)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="1.5"
        />
        
        {/* Sun behind clouds */}
        <circle
          cx="70"
          cy="30"
          r="8"
          fill="rgb(251, 191, 36)"
          opacity="0.8"
        />
        
        {/* Sun rays */}
        <g stroke="rgb(251, 191, 36)" strokeWidth="1.5" strokeLinecap="round" opacity="0.6">
          <line x1="70" y1="15" x2="70" y2="18" />
          <line x1="82" y1="22" x2="80" y2="24" />
          <line x1="85" y1="30" x2="82" y2="30" />
          <line x1="82" y1="38" x2="80" y2="36" />
        </g>
        
        {/* Rain drops */}
        <g fill="rgb(59, 130, 246)">
          <ellipse cx="35" cy="70" rx="1.5" ry="3" />
          <ellipse cx="50" cy="75" rx="1.5" ry="3" />
          <ellipse cx="65" cy="72" rx="1.5" ry="3" />
        </g>
      </svg>
    </div>
  );
};

// Visibility Icon
const Visibility = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Eye outline */}
        <path
          d="M 20 50 C 30 30 70 30 80 50 C 70 70 30 70 20 50 Z"
          fill="rgb(249, 250, 251)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
        />
        
        {/* Iris */}
        <circle
          cx="50"
          cy="50"
          r="12"
          fill="rgb(59, 130, 246)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="1"
        />
        
        {/* Pupil */}
        <circle
          cx="50"
          cy="50"
          r="6"
          fill="rgb(17, 24, 39)"
        />
        
        {/* Eye highlight */}
        <circle
          cx="47"
          cy="47"
          r="2"
          fill="white"
        />
        
        {/* Visibility distance lines */}
        <g stroke="rgb(34, 197, 94)" strokeWidth="2" strokeLinecap="round" opacity="0.7">
          <line x1="85" y1="45" x2="95" y2="40" />
          <line x1="85" y1="50" x2="95" y2="50" />
          <line x1="85" y1="55" x2="95" y2="60" />
        </g>
        
        {/* Distance markers */}
        <g fill="rgb(34, 197, 94)" opacity="0.7">
          <circle cx="88" cy="42" r="1" />
          <circle cx="91" cy="52" r="1" />
          <circle cx="88" cy="58" r="1" />
        </g>
      </svg>
    </div>
  );
};

// Vibration Icon
const Vibration = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Central object being vibrated */}
        <rect
          x="40"
          y="40"
          width="20"
          height="20"
          fill="rgb(156, 163, 175)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
          rx="3"
        />
        
        {/* Vibration waves - left side */}
        <g stroke="rgb(251, 191, 36)" strokeWidth="2" fill="none" strokeLinecap="round">
          <path d="M 35 50 Q 30 45 25 50 Q 30 55 35 50" />
          <path d="M 30 50 Q 25 45 20 50 Q 25 55 30 50" />
          <path d="M 25 50 Q 20 45 15 50 Q 20 55 25 50" />
        </g>
        
        {/* Vibration waves - right side */}
        <g stroke="rgb(251, 191, 36)" strokeWidth="2" fill="none" strokeLinecap="round">
          <path d="M 65 50 Q 70 45 75 50 Q 70 55 65 50" />
          <path d="M 70 50 Q 75 45 80 50 Q 75 55 70 50" />
          <path d="M 75 50 Q 80 45 85 50 Q 80 55 75 50" />
        </g>
        
        {/* Vibration waves - top */}
        <g stroke="rgb(251, 191, 36)" strokeWidth="2" fill="none" strokeLinecap="round">
          <path d="M 50 35 Q 45 30 50 25 Q 55 30 50 35" />
          <path d="M 50 30 Q 45 25 50 20 Q 55 25 50 30" />
        </g>
        
        {/* Vibration waves - bottom */}
        <g stroke="rgb(251, 191, 36)" strokeWidth="2" fill="none" strokeLinecap="round">
          <path d="M 50 65 Q 45 70 50 75 Q 55 70 50 65" />
          <path d="M 50 70 Q 45 75 50 80 Q 55 75 50 70" />
        </g>
        
        {/* Motion blur effect */}
        <rect
          x="42"
          y="42"
          width="16"
          height="16"
          fill="rgb(156, 163, 175)"
          opacity="0.3"
          rx="2"
        />
      </svg>
    </div>
  );
};

// Relay Icon
const Relay = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Relay housing */}
        <rect
          x="25"
          y="30"
          width="50"
          height="40"
          fill="rgb(249, 250, 251)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
          rx="4"
        />
        
        {/* Relay coil */}
        <rect
          x="30"
          y="35"
          width="15"
          height="15"
          fill="none"
          stroke="rgb(143, 148, 151)"
          strokeWidth="1.5"
          rx="2"
        />
        
        {/* Coil windings */}
        <g stroke="rgb(168, 85, 247)" strokeWidth="1" fill="none">
          <circle cx="37.5" cy="42.5" r="3" opacity="0.8" />
          <circle cx="37.5" cy="42.5" r="5" opacity="0.6" />
          <circle cx="37.5" cy="42.5" r="7" opacity="0.4" />
        </g>
        
        {/* Relay contacts - normally open */}
        <g stroke="rgb(143, 148, 151)" strokeWidth="2" strokeLinecap="round">
          <line x1="55" y1="40" x2="60" y2="37" />
          <line x1="55" y1="45" x2="60" y2="45" />
        </g>
        
        {/* Contact terminals */}
        <g fill="rgb(156, 163, 175)">
          <circle cx="55" cy="40" r="1.5" />
          <circle cx="60" cy="37" r="1.5" />
          <circle cx="55" cy="45" r="1.5" />
          <circle cx="60" cy="45" r="1.5" />
        </g>
        
        {/* Input terminals */}
        <g stroke="rgb(143, 148, 151)" strokeWidth="2" strokeLinecap="round">
          <line x1="30" y1="25" x2="30" y2="30" />
          <line x1="45" y1="25" x2="45" y2="30" />
        </g>
        
        {/* Output terminals */}
        <g stroke="rgb(143, 148, 151)" strokeWidth="2" strokeLinecap="round">
          <line x1="55" y1="70" x2="55" y2="75" />
          <line x1="65" y1="70" x2="65" y2="75" />
        </g>
        
        {/* Relay state indicator */}
        <circle
          cx="65"
          cy="55"
          r="4"
          fill="rgb(34, 197, 94)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="1"
        />
        
        {/* ON indicator */}
        <text
          x="65"
          y="58"
          textAnchor="middle"
          fontSize="5"
          fill="white"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          ON
        </text>
        
        {/* Relay label */}
        <text
          x="50"
          y="88"
          textAnchor="middle"
          fontSize="7"
          fill="rgb(143, 148, 151)"
          fontFamily="Arial, sans-serif"
          fontWeight="bold"
        >
          RELAY
        </text>
      </svg>
    </div>
  );
};

// Default/Generic Sensor Icon
const DefaultSensor = ({ className = "sidebar-icon" }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Sensor housing */}
        <rect
          x="30"
          y="25"
          width="40"
          height="50"
          fill="rgb(249, 250, 251)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
          rx="5"
        />
        
        {/* Sensor display/screen */}
        <rect
          x="35"
          y="30"
          width="30"
          height="20"
          fill="rgb(17, 24, 39)"
          rx="2"
        />
        
        {/* Digital display elements */}
        <g fill="rgb(34, 197, 94)">
          <rect x="38" y="33" width="2" height="6" />
          <rect x="42" y="35" width="2" height="4" />
          <rect x="46" y="32" width="2" height="7" />
          <rect x="50" y="34" width="2" height="5" />
          <rect x="54" y="33" width="2" height="6" />
          <rect x="58" y="36" width="2" height="3" />
        </g>
        
        {/* Sensor controls/buttons */}
        <circle cx="40" cy="60" r="3" fill="rgb(156, 163, 175)" stroke="rgb(143, 148, 151)" strokeWidth="1" />
        <circle cx="60" cy="60" r="3" fill="rgb(156, 163, 175)" stroke="rgb(143, 148, 151)" strokeWidth="1" />
        
        {/* Signal indicator */}
        <g stroke="rgb(34, 197, 94)" strokeWidth="1.5" fill="none">
          <path d="M 20 45 Q 25 40 30 45" />
          <path d="M 15 45 Q 22.5 35 30 45" />
          <path d="M 10 45 Q 20 30 30 45" />
        </g>
      </svg>
    </div>
  );
};

// Door/Contact Sensor Icon
const DoorContact = ({ className = "sidebar-icon", isOpen = false }) => {
  return (
    <div className={className}>
      <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 100 100"
      >
        {/* Door frame */}
        <rect
          x="25"
          y="15"
          width="50"
          height="70"
          fill="none"
          stroke="rgb(143, 148, 151)"
          strokeWidth="3"
          rx="2"
        />

        {/* Door panel */}
        <rect
          x={isOpen ? "30" : "28"}
          y="18"
          width={isOpen ? "40" : "44"}
          height="64"
          fill={isOpen ? "rgb(249, 250, 251)" : "rgb(229, 231, 235)"}
          stroke="rgb(143, 148, 151)"
          strokeWidth="2"
          rx="1"
          transform={isOpen ? "skewY(-3)" : ""}
        />

        {/* Door handle */}
        <circle
          cx={isOpen ? "64" : "66"}
          cy="52"
          r="3"
          fill="rgb(156, 163, 175)"
          stroke="rgb(143, 148, 151)"
          strokeWidth="1.5"
        />

        {/* Status indicator - color indicates open (red) or closed (green) */}
        <circle
          cx="50"
          cy="90"
          r="4"
          fill={isOpen ? "rgb(239, 68, 68)" : "rgb(34, 197, 94)"}
        />
      </svg>
    </div>
  );
};

// Export all components
export {
  Temperature,
  Humidity,
  Pressure,
  Distance,
  AirQuality,
  Light,
  Electricity,
  UV,
  Weather,
  Visibility,
  Vibration,
  Relay,
  DoorContact,
  DefaultSensor
};
